import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserInfo } from "../api/auth";
import { FaHome, FaUsers, FaListAlt, FaTint } from "react-icons/fa"; // FaUserFriendsを削除
import "./Header.css";

const Header = () => {
  const [username, setUsername] = useState(null);
  const [isPWA, setIsPWA] = useState(false);
  const [sharedView, setSharedView] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // 現在のパスに基づいてアクティブなナビゲーションを判定
  const isActive = (path) => {
    if (path === "/dashboard" && location.pathname === "/") {
      return true;
    }
    return location.pathname.startsWith(path);
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await getUserInfo();
        if (userData) {
          setUsername(userData.username);
          setSharedView(userData.sharedView === true);
        } else {
          setUsername("ゲスト");
        }
      } catch {
        setUsername("ゲスト");
      }
    };

    fetchUser();

    const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
    setIsPWA(isStandalone);
  }, []);

  return (
    <header className="top-nav">
      {/* ユーザー名を上部に固定 */}
      <span className="user-name">
        {username} 様 {sharedView && <span className="shared-tag">（共有参加中）</span>}
      </span>

      {/* PWAモードでない場合はヘッダーにメニューを表示 */}
      {!isPWA && (
        <nav className="nav-menu">
          <button 
            className={isActive("/dashboard") ? "active" : ""} 
            onClick={() => navigate("/dashboard")}
          > 
            <FaHome className="nav-icon" /> 
            <span>ホーム</span> 
          </button>
          
          <button 
            className={isActive("/clientList") ? "active" : ""} 
            onClick={() => navigate("/clientList")}
          > 
            <FaUsers className="nav-icon" /> 
            <span>顧客一覧</span> 
          </button>
          
          <button 
            className={isActive("/supply-History") ? "active" : ""} 
            onClick={() => navigate("/supply-History")}
          > 
            <FaListAlt className="nav-icon" /> 
            <span>履歴</span> 
          </button>
          
          <button 
            className={isActive("/supply-registration") ? "active" : ""} 
            onClick={() => navigate("/supply-registration")}
          > 
            <FaTint className="nav-icon" /> 
            <span>供給登録</span> 
          </button>
        </nav>
      )}

      {/* PWAモードならボトムナビゲーションを表示 */}
      {isPWA && (
        <nav className="bottom-nav">
          <button 
            className={isActive("/dashboard") ? "active" : ""} 
            onClick={() => navigate("/dashboard")}
          > 
            <FaHome className="nav-icon" /> 
            <span>ホーム</span> 
          </button>
          
          <button 
            className={isActive("/clientList") ? "active" : ""} 
            onClick={() => navigate("/clientList")}
          > 
            <FaUsers className="nav-icon" /> 
            <span>顧客</span> 
          </button>
         
          <button 
            className={isActive("/supply-History") ? "active" : ""} 
            onClick={() => navigate("/supply-History")}
          > 
            <FaListAlt className="nav-icon" /> 
            <span>履歴</span> 
          </button>
          
          <button 
            className={isActive("/supply-registration") ? "active" : ""} 
            onClick={() => navigate("/supply-registration")}
          > 
            <FaTint className="nav-icon" /> 
            <span>供給</span> 
          </button>
        </nav>
      )}
    </header>
  );
};

export default Header;